import styled from 'styled-components';

const CardContainer = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  min-height: 420px;
  max-width: 360px;
  min-width: 265px;
  padding: 10px 30px 10px 25px;
  color: #7e8589;

  @media (min-width: 700px) {
    justify-self: center;
    align-self: center;
  }

  @media (max-width: 865px) {
    margin-right: 20px;
  }
`;

const CardTitle = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  font-weight: 400;
  font-size: 1.6em;
`;

const CardText = styled.p`
  font-size: inherit;
  display: inline-block;
  padding: 0;
  margin-bottom: 25px;
`;

const CardBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const CardInput = styled.input`
  margin-top: 20px;
  width: 100%;
  height: 40px;
  outline: 0;
  border: 0;
  font-family: 'Montserrat';
  border-radius: 8px;
  background-color: #e9ecef;
  color: #323637;
  font-size: 14px;
  text-indent: 10px;
  font-weight: 400;
  &::placeholder {
    font-weight: 400;
    color: #323637;
  }
`;

const activeTogglerBG = '#E7F3EB';
const activeTogglerBorder = '#39B54A';
const activeTogglerFill = '#74CB80';

const Toggler = styled.div`
  width: 50px;
  height: 24px;
  border-radius: 20px;
  position: relative;
  background-color: rgba(238, 42, 36, 0.3);
  border: 1px solid #ee2a24;
  transition: all ease 0.3s;

  &:hover {
    cursor: pointer;
  }

  &:before {
    content: '';
    position: absolute;
    height: 90%;
    width: 20px;
    border-radius: 50%;
    top: 1px;
    left: 2px;
    background-color: #ee2a24;
    z-index: 15;
    transition: all ease 0.3s;
  }

  &.active {
    background-color: ${activeTogglerBG};
    border: 1px solid ${activeTogglerBorder};

    &::before {
      background-color: ${activeTogglerFill};
      transform: translateX(127%);
    }
  }
`;

const FormButton = styled.button`
  background: #003876;
  position: relative;
  width: 120px;
  height: 40px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  outline: 0;
  border-radius: 8px;
  margin-left: auto;
  font-size: 1rem;
  font-weight: 600;
  text-transform: uppercase;
  transition: all 0.35s;
  margin-bottom: 20px;

  &:hover {
    cursor: pointer;
    background: #0b5ba3;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.6);
  }

  &:disabled {
    background-color: #bec3c5;
    color: #7d8589;
  }
`;

const GhostButton = styled.button`
  background: #fff;
  width: 120px;
  height: 40px;
  position: relative;
  color: #003876;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #003876;
  outline: 0;
  border-radius: 8px;
  margin-right: auto;
  font-size: 1rem;
  font-weight: 600;
  text-transform: uppercase;
  transition: all 0.3s;
  margin-bottom: 20px;

  &:hover {
    cursor: pointer;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.6);
  }

  &:disabled {
    background-color: #bec3c5;
    color: #7d8589;
    border: 0;
  }
`;

//  flexDirection:'row', justifyContent:'center', alignItems:'center'}}>

const FormRow = styled.div`
  margin-top: 20px;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;
export {
  FormRow,
  GhostButton,
  Toggler,
  CardContainer,
  FormButton,
  CardTitle,
  CardText,
  CardBody,
  CardInput,
};
